export default "__VITE_ASSET__vVCGWXyi__"